const SAFE_MODE_KEY = 'app-safe-mode';
const SAFE_PARAM = 'safe=1';

/**
 * Returns true if the app is in "safe mode" (no full page reloads).
 * Set via URL: ?safe=1 — use this to break a reload loop (e.g. after clearing SW/cache).
 */
export function isSafeMode(): boolean {
    if (typeof window === 'undefined') return false;
    const url = window.location.search;
    if (url.includes(SAFE_PARAM)) {
        try {
            sessionStorage.setItem(SAFE_MODE_KEY, '1');
        } catch {
            // ignore
        }
        return true;
    }
    try {
        return sessionStorage.getItem(SAFE_MODE_KEY) === '1';
    } catch {
        return false;
    }
}
